var PubSub = require("underpub-js");
var textFit = require("textfit");
var Cookies = require("js-cookie");

var heroHomepage = function(options){

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

heroHomepage.prototype.init = function(){

	var self = this;

	// textfit
	textFit($('.text-fit'), {maxFontSize: 92, minFontSize: 6});

	// on window resize
	PubSub.subscribe("resized", function(){
		textFit($('.text-fit'), {maxFontSize: 92, minFontSize: 6});
	});

	window.setInterval(function() {
		textFit($('.text-fit'), {maxFontSize: 92, minFontSize: 6});
	}, 200);

	// draggable stickers

	// if cookies are set, position stickers accordingly
    var sticker1Left = Cookies.get('sticker1Left');
    var sticker1Top = Cookies.get('sticker1Top');
    var sticker2Left = Cookies.get('sticker2Left');
    var sticker2Top = Cookies.get('sticker2Top');
    var sticker3Left = Cookies.get('sticker3Left');
    var sticker3Top = Cookies.get('sticker3Top');

    console.log('cookie value sticker 1 left: ' + sticker1Left);

    if ((typeof(sticker1Left) != 'undefined') && (typeof(sticker1Top) != 'undefined'))
    {

        self.options.$el.find('.sticker-one').css('left', sticker1Left + 'px');
        self.options.$el.find('.sticker-one').css('top', sticker1Top + 'px');
    }

    if ((typeof(sticker2Left) != 'undefined') && (typeof(sticker2Top) != 'undefined'))
    {
        self.options.$el.find('.sticker-two').css('left', sticker2Left + 'px');
        self.options.$el.find('.sticker-two').css('top', sticker2Top + 'px');
    }

    if ((typeof(sticker3Left) != 'undefined') && (typeof(sticker3Top) != 'undefined'))
    {
        self.options.$el.find('.sticker-three').css('left', sticker3Left + 'px');
        self.options.$el.find('.sticker-three').css('top', sticker3Top + 'px');
    }

    self.options.$el.find('.sticker').removeClass('not-visible');

    $(".draggable").draggable({
        stop: function(event, ui) {

            console.log('drag stop');

            console.log(ui);
            
            console.log('top: ' + ui.position.top);
            console.log('left: ' + ui.position.left);

            var stickerNum = $(this).data('stickerNum');

            Cookies.set('sticker'+stickerNum+'Top', ui.position.top);
            Cookies.set('sticker'+stickerNum+'Left', ui.position.left);

        },
        containment: "[data-hero-homepage]"
    });

};

module.exports = heroHomepage;
